import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fullNameDegrees' })
export class FullNameDegreesPipe implements PipeTransform {
  transform(input: any): string {
    if (!input) {
      return input;
    }
    let name = '';
    if (input.first_name) {
      name = input.first_name;
    }
    if (input.last_name) {
      name += ' ' + input.last_name;
    }
    if (input.degrees && input.degrees.length) {
      name += ', ' + input.degrees.join(', ');
    }
    return name;
  }
}
